import './search.css';
import React, { Component } from 'react';
import Translator from './../../requests/apa/Translator';
import { withKeyboard } from '../../components/FormGroup';
import Scrollable from '../../components/Scrollable';
import Ribbon from '../../components/Ribbon';
import RequestManager from '../../requests/RequestManager';
import PredictiveSearchV1Task from '../../requests/tasks/search/v1/PredictiveSearchV1Task';
import Utils from '../../utils/Search';
import AnalyticsDimensionSingleton from '../../components/Header/AnalyticsDimensionSingleton';
import SearchFlag from './SearchFlag';
import {getContentAvailability, getNavDataNodeByCode, getNavDataNodeById} from '../../utils/Utils';
import {GA4} from 'src/utils/trackers/GA4';
import { ClearTextSearch } from '../../components/PersistentMiniEpg/MiniObserver';
import LoadingIptvOttFlow from 'src/AAF/LoaderExp/LoadingIptvOttFlow';
import logger from 'src/utils/logger/logger';
import {removeDynamicFocus} from "../../components/Focus/utils";
import UtilsSearch from "./UtilsSearch";
import Utilsu from '../../utils/Utils';

class Search extends Component {
  constructor() {
    super();
    this.state = {
      predictive: null,
      suggest: null,
      flag: false,
      text: '',
    };
    this.searchTimeOut = null;
    this._isMounted = false;

    // Bindings estables en constructor
    this.hasFocused = this.hasFocused.bind(this);
    this.makeScrolleable = this.makeScrolleable.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.searchByText = this.searchByText.bind(this);
    this._setSearchContainerRef = this._setSearchContainerRef.bind(this);
    this._onSearchTextChange = this._onSearchTextChange.bind(this);

    this.pTalents = {external_talents: {gracenote: [], keyApa: 'predictSearch_external_talents_label', typeCarousel:'user-profile'}};
    this.divScrolleable = null;
    this.searchContainerRef = null;
    this.isMagicControlActive = Utilsu.getMagicControlKey();

    // Cache para evitar recrear ribbons en cada render si los datos no cambiaron
    this._cachedRibbonResult = null;
    this._prevPredictive = null;
    this._prevSuggest = null;
    this._scrollClassName = this.isMagicControlActive ? "search-result-with-scroll" : "";
  }

  componentDidMount() {
    this._isMounted = true;
    ClearTextSearch.subscribe(this.clearTextSearch);
    this.addEventListeners();
    SearchFlag.setFlag(false);

    if(!LoadingIptvOttFlow.isLoadLive()){
      if (this.props && typeof this.props.loadLinealChannels === 'function') {
        this.props.loadLinealChannels();
      }
      if (this.props && typeof this.props.chargeLiveComponents === 'function') {
        this.props.chargeLiveComponents();
      }
    }
    if (this.divScrolleable) {
      this.divScrolleable.addEventListener('wheel', this.handleScroll, true);
      this.divScrolleable.addEventListener('pointerMove', this.handleScroll, true);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    removeDynamicFocus();
    this.removeEventListeners();
    SearchFlag.setFlag(false);
    ClearTextSearch.unsubscribe(this.clearTextSearch);

    // Limpiar timer pendiente de búsqueda
    if (this.searchTimeOut) {
      clearTimeout(this.searchTimeOut);
      this.searchTimeOut = null;
    }

    if (this.divScrolleable) {
      this.divScrolleable.removeEventListener('wheel', this.handleScroll, true);
      this.divScrolleable.removeEventListener('pointerMove', this.handleScroll, true);
    }

    // Nulificar referencias para liberar memoria en PS4
    this.divScrolleable = null;
    this.searchContainerRef = null;
    this._cachedRibbonResult = null;
    this._prevPredictive = null;
    this._prevSuggest = null;
  }

  componentDidUpdate() {
    if(SearchFlag.getFlag()){
      SearchFlag.setFlag(false);
      if(this.props && (typeof this.props.resetValues === 'function')){
        this.props.resetValues();
      }
    }
  }

  addEventListeners() {
    if (this.searchContainerRef) {
      this.searchContainerRef.addEventListener("sn:focused", this.hasFocused);
    }
  }

  removeEventListeners() {
    if (this.searchContainerRef) {
      this.searchContainerRef.removeEventListener("sn:focused", this.hasFocused);
    }
  }

  clearTextSearch = function() {
    logger.debug('Desmontando el componente');
    SearchFlag.setFlag(true);
    if (this._isMounted) {
      this.setState({
        predictive: null,
        suggest: null,
        flag: true,
        text: '',
      });
    }
  }.bind(this);

  hasFocused(e) {
    const direction = e.detail.direction;
    if(direction === 'right'){
      this.sendMetric();
    } else if(direction === 'down' || direction === 'up'){
      if(!e.target.classList.contains('form-group-focus')){
        const element = e.target.parentNode.parentNode.parentNode;
        element.scrollIntoView(false);
      }
    }
  }

  sendDimension(){
    const payload = new AnalyticsDimensionSingleton().getPayload();
    this.props.setMetricsEvent(payload);
    this.props.setMetricsEvent({ type: 'executor'});
  }

  sendMetric(){
    if(window.location.toString().indexOf('search') !== -1) {
      if (typeof this.props.setMetricsEvent === 'function' && typeof this.props.setMetricFlag === 'function' && typeof this.props.getMetricFlag === 'function') {
        const text = this.props.formValues.input_search_0;

        if (text !== '' && this.props.getMetricFlag() === false) {
          this.props.setMetricsEvent({
            hitType: 'event',
            eventCategory: 'busqueda',
            eventAction: 'palabra/frase buscada',
            eventLabel: text
          });
          this.props.setMetricsEvent({type: 'executor'});
          this.sendDimension();
          this.props.setMetricFlag(true);
        }
      }
    }
  }

  sendGA4Metric(text) {
    const gA4 = new GA4();
    gA4.sendSearchEvent(text);
  }

  isComponentSerch(){
    const isActiveSearch = document.activeElement.className;
    if ( isActiveSearch === '' && ( isActiveSearch.includes !== 'kbd-btn' && isActiveSearch !==  'form-group-value form-group-value-text ')) {
      return false;
    }
    return true;
  }

  _onSearchTextChange(text) {
    if (text !== this.state.text) {
      this.searchByText(text);
    }
  }

  searchByText(text) {
    if(!this.isComponentSerch()) return;

    if (this.searchTimeOut) {
      clearTimeout(this.searchTimeOut);
    }

    this.props.setMetricFlag(false);

    if (text !== this.state.text) {
      this.searchTimeOut = setTimeout(() => {
        if (text && text.length && text.length >= 3) {
          this.sendGA4Metric(text);
        }

        const searchTask = new PredictiveSearchV1Task({ value: text });
        RequestManager.addRequest(searchTask)
          .then((data) => {
            if (!this._isMounted) return;

            if (data.response != null) {
              this.setState({
                predictive: data.response.prediction,
                suggest: data.response.suggest,
                flag: true,
                text: text,
              });
            } else {
              if (text === '') {
                this.setState({
                  flag: false,
                  text: '',
                });
              } else {
                this.setState({ flag: false });
              }
            }
          })
          .catch((e) => {
            logger.debug(e);
            this.setState({ flag: false })
          });
      }, 1000);
    }
  }

  isEmpty(obj) {
    if (!obj) return true;
    const keys = Object.keys(obj);
    return keys.length === 0;
  }

  setValuesTalentsAndExternal(result){
    const talentsProperties = result.map(talent => ({
      first_name: talent.first_name,
      id: talent.id,
      image: talent.image,
      internal_ids: talent.internal_ids,
      last_name: talent.last_name,
      fullname: talent.last_name + ' ' + talent.first_name,
      provider: talent.type ? '2' : '3'
    }));

    return this.setEventhandle(talentsProperties);
  }

  setValuesTalents(resultTalents){
    const result = [];
    const talentKeys = Object.keys(resultTalents);
    for (let i = 0; i < talentKeys.length; i++) {
      const tmpTalent = resultTalents[talentKeys[i]];
      if(tmpTalent){
        const nameParts = tmpTalent.name.split(' ');
        tmpTalent.first_name = nameParts[0];
        tmpTalent.last_name = nameParts[1];
        tmpTalent.internal_ids = [tmpTalent.id];
        result.push(tmpTalent);
      }
    }
    return this.setValuesTalentsAndExternal(result);
  }

  setEventhandle(talentsProperties){
    return talentsProperties.map(talent => ({
      first_name: talent.first_name,
      id: talent.id,
      image: talent.image,
      internal_ids: talent.internal_ids,
      last_name: talent.last_name,
      fullname: talent.last_name + ' ' + talent.first_name,
      provider: talent.provider,
      clickHandler: () => {
        this.handleTalentClick(talent);
      }
    }));
  }

  handleTalentClick = function(talent) {
    const history = this.props.history;
    history.push('/talent/' + talent.id + '/' + talent.fullname + '/' + talent.provider);
  }.bind(this);

  combineTalents(talents, external_talents){
    const result = [];
    const extKeys = Object.keys(external_talents);
    for (let i = 0; i < extKeys.length; i++) {
      if(external_talents[extKeys[i]]){
        result.push(external_talents[extKeys[i]]);
      }
    }
    const talentKeys = Object.keys(talents);
    for (let j = 0; j < talentKeys.length; j++) {
      const tmpTalent = talents[talentKeys[j]];
      if(tmpTalent){
        const nameParts = tmpTalent.name.split(' ');
        tmpTalent.first_name = nameParts[0];
        tmpTalent.last_name = nameParts[1];
        tmpTalent.internal_ids = [tmpTalent.id];
        result.push(tmpTalent);
      }
    }

    return this.setValuesTalentsAndExternal(result);
  }

  handleScroll() {
    removeDynamicFocus();
  }

  setRefScroll = function(element) {
    if(this.isMagicControlActive){
      this.divScrolleable = element;
    }
  }.bind(this);

  _setSearchContainerRef(el) {
    this.searchContainerRef = el;
    this.setRefScroll(el);
  }

  _buildRibbons(prediction, idsRibbonsUpAndDown) {
    const predictionKeys = Object.keys(prediction);
    const ribbons = [];

    for (let i = 0; i < predictionKeys.length; i++) {
      const key = predictionKeys[i];
      const section = prediction[key];
      if (!section) continue;

      const sectionKeys = Object.keys(section);
      for (let j = 0; j < sectionKeys.length; j++) {
        const k = sectionKeys[j];
        if (k === 'keyApa' || k === 'typeCarousel' || k === 'textDefault') continue;
        if (!Array.isArray(section[k])) continue;

        const item = section[k];
        const type = section.typeCarousel;
        if (item.length < 2 && type === 'text') continue;

        const titleKey = section.keyApa;
        ribbons.push(
          <Ribbon
            id={"buscador"}
            key={key + '_' + k}
            title={Translator.get(titleKey, section.textDefault)}
            type={type}
            items={item}
            hideInnerTitle={true}
            setMetricsEvent={this.props.setMetricsEvent}
            carruselTitle={Translator.get(titleKey, key)}
            user={this.props.user}
            idsRibbonsUpAndDown={idsRibbonsUpAndDown}
            index={i}
          />
        );
      }
    }

    return ribbons;
  }

  makeScrolleable(predictive, suggest) {
    // Si los datos no cambiaron, reutilizar el resultado cacheado
    if (predictive === this._prevPredictive && suggest === this._prevSuggest && this._cachedRibbonResult) {
      return this._cachedRibbonResult;
    }
    this._prevPredictive = predictive;
    this._prevSuggest = suggest;

    let keySuggest = 'suggests';
    const text = this.state.text;
    let ribbon = null;

    // Procesar talents
    if(predictive.talents && predictive.external_talents){
      if(predictive.external_talents && predictive.external_talents !== undefined) {
        predictive.external_talents.gracenote = this.combineTalents(predictive.talents.talent, predictive.external_talents.gracenote);
      }
    }
    else if(predictive.talents === undefined && predictive.external_talents){
      predictive.external_talents.gracenote = this.setValuesTalentsAndExternal(predictive.external_talents.gracenote);
    }
    else if(predictive.talents && !predictive.external_talents){
      Object.assign(predictive, this.pTalents);
      predictive.external_talents.gracenote = this.setValuesTalents(predictive.talents.talent);
    }

    const newSuggest = {};
    if(suggest.length !== 0){
      newSuggest.suggest = suggest;
    }
    const prediction = Utils.parserSections(predictive);
    const searchPriority = Utils.getSearchPriority();
    if(searchPriority.searchPriority.length !== 0) {
      const foundKey = searchPriority.searchPriority.reduce(function(acc, key) {
        if (key.indexOf('suggest') > -1) acc.push(key);
        return acc;
      }, []);
      keySuggest = foundKey.length > 0 ? foundKey : keySuggest;
    }

    prediction[keySuggest] = newSuggest;

    if (Object.keys(predictive).length !== 0 || suggest.length !== 0) {
      let _prediction = Utils.handler(prediction);
      _prediction = Utils.orderPriority(_prediction);

      const idsRibbonsUpAndDown = UtilsSearch.createObjectsWithIdsUpDown(_prediction);
      ribbon = this._buildRibbons(_prediction, idsRibbonsUpAndDown);
    }

    const isEmptyResult = this.isEmpty(predictive) && suggest.length === 0 && this.state.flag === true;

    this._cachedRibbonResult = (
      <Scrollable height={'540px'} className="results">
        {isEmptyResult &&
          <div>
            {Translator.get('search_empty_result_text', 'Lo sentimos! Parece que no hay coincidencias')} {text}
          </div>
        }
        {this.state.flag === true &&
          <div className={this._scrollClassName} ref={this.setRefScroll}>
            {ribbon}
          </div>
        }
      </Scrollable>
    );

    return this._cachedRibbonResult;
  }

  render() {
    const predictive = Object.assign({}, this.state.predictive);
    let suggest = [];

    if (this.state.suggest){
      suggest = Utils.getSuggest(this.state.suggest);
    }

    return (
      <div className="main search" ref={this._setSearchContainerRef}>
        {this.props.renderGroup(
          'input_search_0',
          Translator.get('search_result_welcome', 'Ingresa tu búsqueda'),
          'text',
          null,
          this._onSearchTextChange
        )}
        {this.makeScrolleable(predictive, suggest)}
      </div>
    );
  }
}
const formValues = {
  input_search_0: ''
};
export default withKeyboard(Search, formValues);



// WEBPACK FOOTER //
// ./src/containers/Search/index2.jsx